import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import Share from "../icons/share"
import classNames from "classnames"

import {
  addCommas,
  formatJPNumberUnit,
} from "../../utils/str"

const styles = theme => ({
  root: {
    padding: "30px 30px 45px 30px",
    boxSizing: "border-box",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: "30px 20px 45px 20px",
    },
  },

  corpLogo: {
    height: "60px",
    width: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    marginRight: "20px",
  },

  logoImg: {
    maxWidth: "60px",
    maxHeight: "60px",
  },

  hpLink: {
    display: "inline-flex",
    alignItems: "flex-end",
  },

  firstRow: {
    borderTop: "1px solid #D8DBDF",
  },

  row: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "row",
    width: "100%",
    fontSize: "13px",
    borderBottom: "1px solid #D8DBDF",
    boxSizing: "border-box",
    padding: "18px 10px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },

  label: {
    flex: 1,
    color: "#000000",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "10px",
      color: "#85878D"
    },
  },

  value: {
    flex: 3,
    color: "#000000",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "10px",
    },
  },

  inline: {
    paddingBottom: "30px",
    display: "inline-flex",
    alignItems: "flex-start",
    width: "100%",
  },

  company: {
    display: "flex",
    alignItems: "center",
    width: "100%",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  companyName: {
    fontSize: "18px",
    fontWeight: "bold",
  },

  buttonContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "10px",
  },

  button: {
    color: "#71737B",
    fontSize: "11px",
    minWidth: "unset",
    minHeight: "unset",
    padding: "5px 10px",
    marginRight: "-10px",
    textDecoration: "none",
    "&:hover": {
      background: "none",
      textDecoration: "underline",
    },
  },

  industryContainer: {
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
    marginBottom: "12px",
  },

  industryItem: {
    marginRight: "5px",
    fontSize: "12px",
  },

  financialStatementsItem: {
    display: "inline-flex",
    width: "100%",
  },

  financialStatementsItemUl: {
    paddingLeft: "15px",
    margin: "0",
  },

  financialStatementsItemLink: {
    display: "inline-flex",
    alignItems: "flex-center",
    color: "#1866FF",
    "&:visited": {
      color: " #13367B",
    }
  },

  rankContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    padding: "0px 12px",
    boxSizing: "border-box",
  },

  rankItem: {
    fontSize: "13px",
    marginBottom: "12px",
  },

  rankTitle: {
    marginRight: "20px",
  },

  rankNo: {
    fontSize: "20px",
    fontWeight: "bold",
    marginRight: "5px",
  },

  rankDesc: {
    fontSize: "11px",
    color: "#71737B",
  },
})

class CorporationProfile extends React.Component {
  state = {
    jsic_l: "",
    jsic_s: "",
  }

  componentDidMount() {
    const { item } = this.props

    if (item && !!item.corporation_detail_detail) {
      const detail = JSON.parse(item.corporation_detail_detail)
      let jsic_l = "",
        jsic_s = ""

      if (detail.hasOwnProperty("jsic_l")) {
        jsic_l = detail["jsic_l"]
      }

      if (detail.hasOwnProperty("jsic_s")) {
        jsic_s = detail["jsic_s"]
        this.props.getRankJsicSById(jsic_s)
      }

      this.setState({
        jsic_l: jsic_l,
        jsic_s: jsic_s,
      })
    }
  }

  renderRow = (item, index) => {
    const { classes } = this.props
    if (item.value && item.value !== "-") {
      return (
        <div className={classNames(
            classes.row,
            index === 0 ? classes.firstRow : ""
          )} key={index}>

          <div className={classes.label}>{item.title}</div>
          <div className={classes.value}>{item.value}</div>
        </div>
      )
    }
  }

  renderIndustry = () => {
    const { classes } = this.props
    const { jsic_l, jsic_s } = this.state

    if (!!jsic_l && !!jsic_s) {
      return (
        <div className={classes.industryContainer}>
          <span className={classes.industryItem}>{jsic_l}, </span>
          <span className={classes.industryItem}>{jsic_s}</span>
        </div>
      )
    } else if (!!jsic_l) {
      return (
        <div className={classes.industryContainer}>
          <span className={classes.industryItem}>{jsic_l}</span>
        </div>
      )
    }
  }

  renderFinancialStatements = () => {
    const { classes, item } = this.props
    let financialStatements = item.financial_statements
    if (financialStatements) {
      // 文字列でJSONが入っているためJSONに明示的に変換
      financialStatements = JSON.parse(financialStatements)
    }

    if (financialStatements && financialStatements.length > 0) {
      return (
        <ul className={classes.financialStatementsItemUl}>
          {financialStatements.map((e, i) => (
            <li key={i} style={{ marginBottom: (i === financialStatements.length - 1) ? "" : "10px" }}>
              <div className={classes.financialStatementsItem}>
                {(() => {
                  if (e.url) {
                    return (<a
                        className={classes.financialStatementsItemLink}
                        href={e.url}
                        target="_blank"
                        rel="noopener"
                        >
                          <span>{e.title}</span>
                          <Share
                            width={18}
                            height={18}
                            color="#71737B"
                            style={{ marginLeft: "5px" }}
                          />
                        </a>
                      )
                  } else {
                    return (
                      <span>{e.title}</span>
                    )
                  }
                })()}
              </div>
            </li>
          ))}
        </ul>
      )
    }
  }

  render() {
    const { classes, item } = this.props

    let financialStatements = item.financial_statements
    if (financialStatements) {
      // 文字列でJSONが入っているためJSONに明示的に変換
      financialStatements = JSON.parse(financialStatements)
    }

    let numberOfEmployees = item.number_of_employees
    if (
      numberOfEmployees === 0 ||
      numberOfEmployees === "0" ||
      numberOfEmployees === "-" ||
      numberOfEmployees === ""
    ) {
      numberOfEmployees = null
    } else {
      numberOfEmployees = addCommas(numberOfEmployees) + "人"
    }

    let clothingMonth = item.clothing_month
    if (
      clothingMonth === 0 ||
      clothingMonth === "0" ||
      clothingMonth === "-" ||
      clothingMonth === ""
    ) {
      clothingMonth = null
    } else {
      clothingMonth = clothingMonth + "月"
    }

    const basicInfo = [
      {
        title: "本社・本店",
        value: item.prefecture_name + item.city_name + item.street_number,
      },
      {
        title: "主要事業所",
        value:
          item.shikiho_main_office &&
          item.shikiho_main_office
            .split("\n")
            .map((line, i) => <div key={i}>{line}</div>),
      },
      { title: "電話番号", value: item.shikiho_tel },
      { title: "連結事業", value: item.shikiho_consolidated_business },
      { title: "従業員数", value: numberOfEmployees },
      {
        title: "資本金",
        value: item.capital_stock
          ? formatJPNumberUnit(item.capital_stock)
          : null,
      },
      {
        title: "売上高",
        value: item.amount_of_sales
          ? formatJPNumberUnit(item.amount_of_sales)
          : null,
      },
      { title: "上場市場", value: item.listing_type },
      { title: "決算月", value: clothingMonth },
      { title: "平均年齢", value: item.average_age },
      { title: "平均年収", value: item.annual_income },
      { title: "法人番号", value: item.corporate_number },
      { title: "証券コード", value: item.shikiho_stock_code },
    ];

    if (financialStatements && financialStatements.length > 0) {
      basicInfo.push(
        { title: "決算報告書", value: this.renderFinancialStatements() }
      );
    }

    return (
      <div className={classes.root}>
        <div className={classes.inline}>
          <div className={classes.corpLogo}>
            <img
              src={
                item.logo_path
                  ? item.logo_path
                  : "https://s3-ap-northeast-1.amazonaws.com/posto-public-production/corporation_logo/no-image/no-image.png"
              }
              alt="logo"
              className={classes.logoImg}
            />
          </div>
          <div>
            {this.renderIndustry()}

            <div className={classes.company}>
              <h3 className={classes.companyName}>{`${
                item.company_name ? item.company_name : item.name
              }について`}</h3>
              {item.shikiho_site_url && (
                <a
                  className={classes.hpLink}
                  style={{ width: "unset" }}
                  href={item.shikiho_site_url}
                  target="_blank"
                  rel="noopener"
                >
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#71737B",
                      marginLeft: "5px",
                    }}
                  >
                    会社HP
                  </span>
                  　
                  <Share
                    width={18}
                    height={18}
                    color="#71737B"
                    style={{ marginLeft: "-15px" }}
                  />
                </a>
              )}
            </div>

            <p style={{ fontSize: "12px", marginTop: "5px" }}>
              {item.shikiho_feature}
            </p>
          </div>
        </div>

        {basicInfo.map((info, i) => this.renderRow(info, i))}
      </div>
    )
  }
}

CorporationProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  jsicSRankStats: PropTypes.object,
  getRankJsicSById: PropTypes.func.isRequired,
}

export default withStyles(styles)(CorporationProfile)
